import request from '@/utils/request'
import qs from 'qs'

// 查询是否有消息
export const getIndexCircleLeft = params => {
    return request({
      url: '/api/deptSupplier/message',
      method: 'GET',
    })
}

// // 获取首页实验室列表
export const getHomeLaboratorys = () => {
  return request({
    url: '/api/homepage/indexShow',
    method: 'GET',
  })
}

// 获取首页左上角数据(图标数据)
export const getHomeChartData = () => {
return request({
  url: '/api/homepage/leftTop',
  method: 'GET'
})
}


// 获取首页右下角数据(订单列表)
export const getHomeOrderList = () => {
return request({
  url: '/api/homepage/lowerRight',
  method: 'GET'
})
}

// 这个没用到
export const getHomeLaboratoryList = () => {
  return request({
    url: '/api/lab/chooseOrder',
    method: 'GET'
  })
}

// 更改收藏状态
export const changeCollectionStatus = (id) => {
  return request({
    url: `/api/lab/favorites/${id}`,
    method: 'PUT'
  })
}

// 获取右上角数据
export const enterpriseTop = () => {
  return request({
      url: '/api/enterprise/top',
      method: 'GET'
  })
}

